import PropTypes from 'prop-types';
import { useCallback, useMemo, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import Container from '@mui/material/Container';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { useSettingsContext } from 'src/components/settings';
import { paths } from 'src/routes/paths';
import Grid from '@mui/material/Unstable_Grid2';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import { useResponsive } from 'src/hooks/use-responsive';
import FormProvider, {
    RHFUpload,
  } from 'src/components/hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Image from 'src/components/image';
import axiosInstance, { API_ENDPOINTS } from 'src/utils/axios';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { alpha , useTheme} from '@mui/system';
import { IconButton, ListItemText } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid';
import { ASSETS_API } from 'src/config-global';

GaleryListView.propTypes = {
    current: PropTypes.object,
  };

  
export default function GaleryListView({ current }) {
  const settings = useSettingsContext();
  const mdUp = useResponsive('up', 'md');
  const [galeryImages,setGaleryImages] = useState([]);
  const theme = useTheme();
  const NewProductSchema = Yup.object().shape({
    images: Yup.array().min(1, 'Images is required'),
  });
  const fetchData = async () => {
    try {
      const res = await axiosInstance.get(API_ENDPOINTS.galery.list);
     setGaleryImages(res.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  const defaultValues = useMemo(
    () => ({
      images: current?.images || []
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [current]
  );

  const methods = useForm({
    resolver: yupResolver(NewProductSchema),
    defaultValues,
  });

  const {
    reset,
    watch,
    setValue,
    handleSubmit,
    getValues,
    formState: { isSubmitting },
  } = methods;

  const values = watch();

  const handleDrop = useCallback(
    (acceptedFiles) => {
      const files = values.images || [];

      const newFiles = acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );

      setValue('images', [...files, ...newFiles], { shouldValidate: true });
    },
    [setValue, values.images]
  );

  const handleRemoveFile = useCallback(
    (inputFile) => {
      const filtered = values.images && values.images?.filter((file) => file !== inputFile);
      setValue('images', filtered);
    },
    [setValue, values.images]
  );

  const onSubmit = useCallback(
    async (data) => {
      try {
        await new Promise((resolve) => setTimeout(resolve, 500));
        reset();
        console.info('DATA', data);
      } catch (error) {
        console.error(error);
      }
    },
    [ reset]
  );
  const handleRemoveAllFiles = useCallback(() => {
    setValue('images', []);
  }, [setValue]);

  const handleUploadImages = async () => {
    const { images } = getValues();
    images.map( async (image) => {
        await axiosInstance.post(`${API_ENDPOINTS.galery.post}`, {imageFile:image},{headers: {"Content-Type":'multipart/form-data'}});
        await fetchData();
      });
      reset();
  }

  const handleRemove = async (id) => {
    await axiosInstance.delete(`${API_ENDPOINTS.galery.delete}${id}`);
    await fetchData();
  };
  const handleDragEnd = async (result,tab) => {
    const sourceOrder = galeryImages[result.source.index].order;
    const destOrder = galeryImages[result.destination.index].order;
    galeryImages[result.source.index].order = destOrder;
    galeryImages[result.destination.index].order = sourceOrder;
    setGaleryImages(galeryImages);
    const t = galeryImages.map(obj => ({order:obj.order, photoId: obj.id}));
    await axiosInstance.put(`${API_ENDPOINTS.galery.order}`, t);
  };
  return (
    <div>
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs
          heading="Galeria"
          links={[
            { name: 'Dashboard', href: paths.dashboard.root },
            { name: 'Galeria', href: paths.dashboard.galeria },
            { name: 'Lista' },
          ]}
          sx={{
            mb: { xs: 3, md: 5 },
          }}
        />
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Grid xs={12} md={8}>
        <Card>
          {!mdUp && <CardHeader title="Details" />}

          <Stack spacing={3} sx={{ p: 3 }}>
            <Stack spacing={1.5} >
              <Typography variant="subtitle2">Images</Typography>
              <RHFUpload
               sx={{maxHeight:'20%'}}
                multiple
                accept={{ 'image/*': []}}
                name="images"
                thumbnail
                maxSize={31457280}
                onDrop={handleDrop}
                onRemove={handleRemoveFile}
                onRemoveAll={handleRemoveAllFiles}
                onUpload={() => handleUploadImages()}
              />
            </Stack>
          </Stack>
        </Card>
      </Grid>
      </FormProvider>
    </Container>
    {galeryImages.length > 0 ? 
    <Container id="photos" maxWidth={settings.themeStretch ? false : 'lg'} sx={{mt:2}}>
        <DragDropContext  onDragEnd={(result) => handleDragEnd(result)}>
            <Droppable droppableId="photos" type="photo" direction='horizontal'>
            {(provided) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                 {
                 galeryImages
                 .sort((a, b) => a.order - b.order)
                 .map((galeryImage, galeryImageIndex) => 
                     (
                     <Draggable key={galeryImage.id} draggableId={galeryImage.id} index={galeryImageIndex}> 
                      {(provided1) => (
                  
                    <Card key={galeryImage.id} 
                     ref={provided1.innerRef} {...provided1.draggableProps} {...provided1.dragHandleProps} sx={{  display: 'inline-flex',width:'23.75%', m:1}}>
             
                    <IconButton aria-label="remove" onClick={() => handleRemove(galeryImage.id)} color="inherit" sx={{ position: 'absolute', top: 8, right: 8, zIndex: 9 }}>
                                <GridCloseIcon />
                              </IconButton>
        
                    <ListItemText
                      sx={{
                        p: 3,
                        left: 0,
                        width: 1,
                        bottom: 0,
                        zIndex: 9,
                        position: 'absolute',
                      }}
                      primaryTypographyProps={{
                        noWrap: true,
                        typography: 'subtitle1',
                      }}
                      secondaryTypographyProps={{
                        mt: 0.5,
                        color: 'inherit',
                        component: 'span',
                        typography: 'body2',
                        sx: { opacity: 0.48 },
                      }}
                    />
        
        <Image 
                         src={`${ASSETS_API}${galeryImage?.photo}`}
                         overlay={alpha(theme.palette.grey[900], 0.48)} maxWidth='100%'
                         /> 
                  </Card>
                        )}
                     </Draggable>)) }
                     {provided.placeholder} 
               </div>)}
            </Droppable>
        </DragDropContext>
    </Container> : null }
    </div>
  );
}
